export default [
  {
    path: "my-attendance",
    name: "my-attendance-attendance",
    component: () => import("@/views/attendance/views/my-attendance/MyAttendance.vue"),
    meta: {
      section: 0,
      pageTitle: "Attendance",
      breadcrumb: [
        {
          text: "my attendance",
          active: true,
        },
      ],
    },
  },
];